import React from "react";
import HomeCarousel from "@components/Home/CarouselHome";
import {
  RECOMMENDED_PLAYLISTS_PAGE_LIMIT,
  RecommendedPlaylistsData,
  useRecommendedPlaylists,
} from "@hooks/trpc/useRecommendedPlaylists";
import { captureException } from "@utils/captureException";

const PopularPlaylists = ({
  title = "Popular Playlists",
}: {
  title?: string;
}) => {
  const { data, fetchNextPage, hasNextPage } = useRecommendedPlaylists();
  const items: RecommendedPlaylistsData[] = data.pages.flatMap(
    (page) => page.data,
  );

  const handleEndReached = () => {
    if (hasNextPage) {
      fetchNextPage().catch((error) => {
        captureException(error, {
          channel: "breadcrumb",
          area: "pagination",
          operation: "fetch-next-popular-playlists",
        });
      });
    }
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <HomeCarousel
      items={items}
      onEndReached={handleEndReached}
      onEndReachedThreshold={RECOMMENDED_PLAYLISTS_PAGE_LIMIT}
      screen="home"
      title={title}
    />
  );
};

export default PopularPlaylists;
